import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import FormatCurrency from 'components/Common/FormatCurrency'

const Root = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;

  ${mediaQueryUp.desktop} {
    position: static;
    display: block;
    max-width: ${rem(360)};
  }
`

const Panel = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  width: 100%;
  max-width: ${rem(360)};
  padding: ${rem(32)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: ${props => props.theme.borderRadius.M};
  position: relative;
  height: 100%;
`

const Layout = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to bottom,transparent 50%,white 50%);

  ${mediaQueryUp.desktop} {
    display: none;
  }
`

const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  margin-top: ${rem(8)};

  & > * {
    overflow: hidden;
  }

  ${mediaQueryUp.desktop} {
    margin-top: 0;
  }
`

const DisplayValue = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${props => props.theme.palette.neutral.default.seven};
  padding: ${rem(16)};
  margin-top: ${rem(16)};

  ${mediaQueryUp.desktop} {
    margin-top: 0;
  }
`

interface Props {
  referralLogTotal: App.ReferralLogTotal
}

function ReferralPanel({ referralLogTotal }: Props) {
  return (
    <Root>
      <Layout />
      <Panel>
        <BodyText variant="large">Track your</BodyText>
        <Heading variant="heading3">Referrals & rewards</Heading>
        <Grid>
          <div>
            <Heading variant="heading3">{referralLogTotal.pending ?? 0}</Heading>
            <BodyText variant="large">Pending</BodyText>
          </div>
          <div>
            <Heading variant="heading3">{referralLogTotal.available_referrals ?? 0}</Heading>
            <BodyText variant="large">Available</BodyText>
          </div>
          <div>
            <Heading variant="heading3">{referralLogTotal.total_amount_redeemed ?? 0}</Heading>
            <BodyText variant="large">Redeemed</BodyText>
          </div>
        </Grid>
        <DisplayValue>
          <BodyText variant="medium">Luxury Escapes Credits</BodyText>
          <Heading variant="heading3"><FormatCurrency value={referralLogTotal.creditsRedeemed || 0} format="dynamicDollar" /></Heading>
        </DisplayValue>
      </Panel>
    </Root>
  )
}

export default ReferralPanel
